import { IconSearch } from "@tabler/icons-react";

const NoCostsFound = () => {
  return (
    <div style={{ textAlign: "center" }}>
      <IconSearch size={120} strokeWidth={1} color="lightsteelblue" />
      <h3>No se encontraron resultados disponibles</h3>
      <h4>Vuelve a intentarlo despues</h4>
    </div>
  );
};

export default NoCostsFound;
